import { combineReducers } from "redux";
import auth from "./auth";
import users from "./users";
import clients from "./clients"; 

export default combineReducers({ auth, users, clients });